export type SpinSector = {
  label: string
  type: 'coupon' | 'free_visit' | 'no_prize'
  value: number
  weight: number
  color: string
}

export function normalizeSectors(sectors: SpinSector[]): SpinSector[] {
  return sectors.filter((sector) => sector.weight > 0 && sector.label.trim().length > 0)
}

export function pickSector(
  sectors: SpinSector[],
  random: () => number = Math.random,
): SpinSector {
  const pool = normalizeSectors(sectors)
  if (!pool.length) {
    throw new Error('گردونه هیچ قطاع معتبری ندارد')
  }
  const total = pool.reduce((sum, sector) => sum + sector.weight, 0)
  let cursor = random() * total
  for (const sector of pool) {
    cursor -= sector.weight
    if (cursor <= 0) return sector
  }
  return pool[pool.length - 1]!
}

export function sectorAngle(index: number, count: number): number {
  if (count <= 0) return 0
  return (360 / count) * index
}

export function winningRotation(index: number, count: number, spins = 5): number {
  const slice = 360 / Math.max(1, count)
  const center = slice * index + slice / 2
  return spins * 360 + (360 - center)
}
